import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffGradesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      staff_id: this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      expiration: '',
      dispatch: '',
      staff_grades: [],
      aircraft_list: [],
    };

    this.locale = getLocale();
  }
  
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_grades)) {
      this.setState({
        staff_grades: newProps.staff_grades,
        loaded: 1
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tituloNiveisDeCargos}</h3>
  <hr/>
  {(this.state.staff_grades === null || typeof this.state.staff_grades === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.nenhumaAeronaveCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.DataDeAlteracao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.Nivel}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.Motivo}</th>
          {/* <th className="col-md-1 text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_grades).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_grades[k].date_str}</td>
              <td className="text-center">{self.state.staff_grades[k].level}</td>
              <td className="text-center">{self.state.staff_grades[k].motivo}</td>
              {/* <td className="text-center">
                  <button className="btn btn-sm btn-danger" value={self.state.staff_grades[k].id} onClick={self.delete}><i className="fa fa-fw fa-power-off"></i></button>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default StaffGradesTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffGradesTab.js